<template>
  <div class="text-center">
    <v-menu offset-y>
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          color="light"
          light
          v-bind="attrs"
          style="padding: 0px"
          v-on="on"
        >
          <div class="center">
            <i class="fas fa-globe-americas" style="font-size: 1.5rem; color: #6c757d;" />
            <i class="fas fa-sort-down ml-2" style="margin-bottom: 5px" />
          </div>
        </v-btn>
      </template>
      <v-list class="mt-1 rounded">
        <v-list-item
          v-for="(lang, i) in langs" :key="i" @click.prevent="changeLang(lang)"
        >
          <v-list-item-title>{{ lang.label }}</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>
  </div>
  <!-- <b-dropdown
    id="lang-dropdown"
    right
    size="sm"
    variant="light"
    no-caret
  >
    <template v-slot:button-content>
      <div class="center">
        <i class="fas fa-globe-americas" style="font-size: 1.5rem; color: #6c757d;" />
        <i class="fas fa-sort-down ml-2" style="margin-bottom: 1px" />
      </div>
    </template>
    <b-dropdown-item v-for="(lang, i) in langs" :key="i" @click.prevent="$i18n.locale = lang.code">
      {{ lang.label }}
    </b-dropdown-item>
  </b-dropdown> -->
</template>

<script lang="ts">
import Vue from 'vue';

export default Vue.extend({
  data() {
    return {
      langs: [
        {
          label: '繁體中文',
          code: 'zh-TW',
        },
        {
          label: 'English',
          code: 'en',
        },
      ],
    };
  },
  methods: {
    changeLang(lang) {
      this.$i18n.locale = lang.code;
      this.$store.commit('updateCurrentLang', lang.label);
    },
  },
});
</script>

<style lang="scss" scoped>
.text-center{
  button{
    padding: 0;
  }
}
.center {
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
